import { BlackListKeywords } from "@/models/crawler.model";
import { CrawlerRest } from "@/services/rest/crawler.rest";
import { BehaviorSubject, map, take } from "rxjs";

export class BlacklistService {
  constructor(private _crawler = new CrawlerRest()) {}

  private $keywords = new BehaviorSubject(new Array<BlackListKeywords>());
  keywords = this.$keywords.asObservable();

  getKeywordsByObjective(objectiveId: string): void {
    this._crawler
      .getKeywordsByObjective(objectiveId)
      .pipe(
        take(1),
        map((e) => {
          e.forEach((item) => {
            item.isEval = item.isEval === -1 ? true : false;
          });
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.$keywords.next(response);
        },
      });
  }
}
